<template>
  <div class="login-bg">
    <div class="login-cont container" style="height: 80vh;">
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <div class="card-body px-2 d-flex mx-0 col-12 mx-auto auth-card-glass">
            <div class="my-auto col-12">
              <div class="text-center mb-4">
                <div class="error text-center py-2" v-if="error">
                  <span class="mx-auto">{{ $t('auth.fail_message') }}</span>
                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.phone }}</small>
                <div class="form-group mb-3">
                  <label class="auth-label">{{ $t('auth.phone') }}</label>
                  <input
                    class="form-control pl-2 px-4 auth-input"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label class="auth-label">{{ $t('auth.password') }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4 auth-input"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password text-dark"
                      v-if="isShow"
                      @click="showablePassword()"
                    ></i>
                    <i
                      v-if="!isShow"
                      class="fas fa-eye-slash showable-password text-dark"
                      @click="showablePassword()"
                    ></i>
                  </div>
                </div>

                <div class="auth-actions">
                  <button
                    type="button"
                    class="auth-btn auth-btn--solid"
                    @click="loginWithPhone()"
                  >
                    <template v-if="!isSignin">
                      <i class="fas fa-sign-in-alt auth-btn__icon" aria-hidden="true"></i>
                      {{ $t('auth.login') }}
                    </template>
                    <Loading v-else color="#ffffff" size="24" class="px-4 py-0" />
                  </button>

                  <button
                    type="button"
                    class="auth-btn auth-btn--outline"
                    @click="$router.push('/auth/register')"
                  >
                    <i class="fas fa-user-plus auth-btn__icon" aria-hidden="true"></i>
                    {{ $t('auth.sign_up') }}
                  </button>

                  <template v-if="showQuickLogin">
                    <div class="auth-divider">
                      <div class="auth-divider__line"></div>
                      <span class="auth-divider__text">OR</span>
                      <div class="auth-divider__line"></div>
                    </div>
                    <button
                      type="button"
                      class="auth-btn auth-btn--quick"
                      @click="quickLogin()"
                    >
                      <template v-if="!isQuickLogin">
                        <i class="fas fa-bolt auth-btn__icon" aria-hidden="true"></i>
                        {{ $t('auth.quick_login') }}
                      </template>
                      <Loading v-else color="#0f172a" size="24" class="px-4 py-0" />
                    </button>
                  </template>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShow: false,
      isQuickLogin: false,
    };
  },
  computed: {
    isPlaySubdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play' || host.startsWith('play.');
    },
    showQuickLogin() {
      return this.isPlaySubdomain;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    showablePassword() {
      this.$refs.password.type = this.isShow ? 'password' : 'text';
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      this.error = false;
      if (!this.name) {
        this.errors.name = this.$t('auth.require_phone');
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t('auth.require_password');
        this.isSignin = false;
        return false;
      }
      try {
        const res = await this.axios.post('/auth/login', {
          phone: this.name,
          password: this.password,
          roles: 'normal',
          fcm: localStorage.getItem('fcm'),
        });
        localStorage.setItem('username', this.name);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000),
        );
        this.axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
        await this.fetchUser();
        this.$router.push('/home');
        Toast.success(this.$store.state.language === 'en' ? 'Success!' : 'Success!');
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
    async quickLogin() {
      this.isQuickLogin = true;
      this.error = false;
      try {
        const deviceUuid = localStorage.getItem('device_uuid');
        const res = await this.axios.post('/auth/login-with-device', {
          device_uuid: deviceUuid,
        });
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000),
        );
        this.axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
        await this.fetchUser();

        if (res.data.is_first_time === 1) {
          const platform =
            this.$route.query.ref ||
            this.$route.query.referrer ||
            localStorage.getItem('user_platform_ref');
          if (platform) {
            try {
              await this.axios.post('/auth/update-user-platform', {
                user_platform: platform.toLowerCase(),
              });
            } catch (err) {
              console.error('Failed to update platform:', err);
            }
          }
        }

        this.$router.push('/home');
        Toast.success('Success!');
      } catch (err) {
        this.error = true;
      }
      this.isQuickLogin = false;
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal') {
      this.$router.push('/home');
    }
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/auth-page.scss';
</style>
